module.exports = __webpack_public_path__ + "img/Icon_RightTools.94a03841.png";